export const TEST_ID = 'mobileNavigationDropdown';
